import React from 'react';
import { ErrorContainer, ErrorCopy, ErrorIcon } from './Error.styles';

interface ErrorProps {
  message?: React.ReactNode;
  iconSize?: number;
  className?: string;
}

const Error: React.FC<ErrorProps> = ({ message, iconSize = 12, className }) => (
  <ErrorContainer className={className || ''}>
    <ErrorIcon width={iconSize} height={iconSize} title="remove-icon" />
    <ErrorCopy data-testid="error-copy">{message}</ErrorCopy>
  </ErrorContainer>
);

export default Error;
